import navCategories from './navCategories';

export default navCategories;
